import {
  usePopoverArrow
} from "../__chunks/SWPAMWUW.js";
import "../__chunks/GM7XQV7F.js";
import "../__chunks/6GS36SYX.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import "../__chunks/PNRLI7OV.js";

// src/menu/menu-arrow.ts
var useMenuArrow = createHook((props) => {
  return usePopoverArrow(props);
});
var MenuArrow = createComponent((props) => {
  const htmlProps = useMenuArrow(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  MenuArrow.displayName = "MenuArrow";
}
export {
  MenuArrow,
  useMenuArrow
};
